import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const SiteStatusContext = createContext({ status: null, refresh: () => {} });

export function SiteStatusProvider({ children }) {
  const [status, setStatus] = useState(null);

  const refresh = useCallback(() => {
    api.get("/site-status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SiteStatusContext.Provider value={{ status, refresh }}>{children}</SiteStatusContext.Provider>;
}

export const useSiteStatus = () => useContext(SiteStatusContext);
